import { calculateNetSalary, TAX_PARAMS_2026 } from '../../../../../utils/salary/calculate-finnish-net-salary';
import type { OriginalSalary } from './salaryConversion';

export interface FinnishNetSalaryEstimate {
  netMin: number;
  netMax: number;
  /** True when the national-average municipal tax rate was used (no per-city rate wired in yet). */
  isGenericEstimate: boolean;
  /** Municipal tax rate % assumed for this estimate, for use in an explainer string. */
  assumedMunicipalRatePct: number;
  /** Tax year the parameters come from, for use in an explainer string. */
  taxYear: number;
}

/**
 * Estimates Finnish take-home pay from a gross salary already converted to EUR/month.
 * Only meaningful for Finland-market jobs — callers must gate on displayJob.isFinland.
 */
export function estimateFinnishNetSalary(
  convertedSalary: OriginalSalary | null,
): FinnishNetSalaryEstimate | null {
  if (!convertedSalary || convertedSalary.currency !== 'EUR') return null;
  if (!(convertedSalary.min > 0) || !(convertedSalary.max > 0)) return null;

  const minResult = calculateNetSalary({ grossMonthly: convertedSalary.min });
  const maxResult = calculateNetSalary({ grossMonthly: convertedSalary.max });

  return {
    netMin: minResult.netMonthly,
    netMax: maxResult.netMonthly,
    isGenericEstimate: minResult.isGenericEstimate,
    assumedMunicipalRatePct: TAX_PARAMS_2026.avgMunicipalRatePct,
    taxYear: TAX_PARAMS_2026.year,
  };
}
